export const accountinfo = {
  email: {
    type: 'input',
    label: 'Communication Email Address',
    value: '',
    config: {
      placeholder: 'Your Email Address',
      help_text: 'You will receive all notifications on this email',
    },
    validation: {
      required: true,
      isEmail: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  bureau: {
    type: 'async_select_single',
    label: 'Bureau',
    value: '',
    config: {
      placeholder: 'Select bureau',
      help_text: 'Select the bureau you registered at',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  first_name: {
    type: 'input',
    value: '',
    config: {
      placeholder: 'Enter only First Name',
      help_text: 'First Name',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  last_name: {
    type: 'input',
    value: '',
    config: {
      placeholder: 'Enter only Last Name',
      help_text: 'Last Name',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  gender: {
    type: 'select',
    label: 'Gender',
    value: '',
    validation: {
      required: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: {
      M: 'Male',
      F: 'Female',
    },
  },
  phone: {
    type: 'input',
    label: 'Mobile No.',
    value: '',
    config: {
      placeholder: 'Enter Mobile no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


const heightOptions = {};
for (let i = 4; i <= 6; i += 1) {
  for (let j = 0; j <= 11; j += 1) {
    const ft = i;
    let inch = j;
    inch += (ft * 12);
    const cm = inch * 2.54;
    heightOptions[parseInt(cm, 10)] = `${i}ft ${j}in`;
  }
}


export const personalinfo = {
  birth_date: {
    type: 'date',
    label: 'Date of Birth (YYYY-MM-DD)',
    value: null,
    config: {
      emptyLabel: 'Select date',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  birth_time: {
    type: 'time',
    label: 'Time of Birth',
    value: null,
    config: {
      emptyLabel: 'Select time',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  birth_place: {
    type: 'async_select_single',
    label: 'Place of Birth',
    value: '',
    config: {
      placeholder: 'Search and select place of birth',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  caste: {
    type: 'async_select_single',
    label: 'Caste',
    value: '',
    config: {
      placeholder: 'Select caste',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  marital_status: {
    type: 'async_select_single',
    label: 'Marital Status',
    value: '',
    config: {
      placeholder: 'Select marital status',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  height: {
    type: 'select',
    label: 'Height',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: heightOptions,
  },
  weight: {
    type: 'input',
    label: 'Weight in kgs',
    value: '',
    config: {
      type: 'number',
      placeholder: 'Enter your weight',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  about: {
    type: 'input',
    label: 'About you',
    value: '',
    config: {
      help_text: 'Max 300 characters allowed. Don\'t mention your education and work. We have a section for that later',
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  marriage_end_year: {
    type: 'input',
    label: 'Year of Divorced/Widowed',
    value: '',
    config: {
      placeholder: 'Please enter year',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  marriage_years_count: {
    type: 'input',
    label: 'No. of years of marriage',
    value: '',
    config: {
      placeholder: 'Please enter duration in months/years',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  children: {
    type: 'input',
    label: 'Children',
    value: '',
    config: {
      placeholder: 'No. of children',
      help_text: 'Enter no. of sons/daughters with age',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  legal: {
    type: 'input',
    label: 'Legality',
    value: '',
    config: {
      placeholder: 'Legal Information',
      help_text: 'Legal papers cleared Yes/No. If yes, which year',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const lifestyleinfo = {
  body_type: {
    type: 'async_select_single',
    label: 'Body Type',
    value: '',
    config: {
      placeholder: 'Select body type',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  physical_disabilities: {
    type: 'input',
    label: 'Physical Disablilities (if any)',
    value: '',
    config: {
      placeholder: 'Enter any physical disabilities',
    },
    errorMsg: '',
    valid: true,
    touched: true,
  },
  diet: {
    type: 'async_select_single',
    label: 'Diet',
    value: '',
    config: {
      placeholder: 'Select diet',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  smoke: {
    type: 'async_select_single',
    label: 'Smoke',
    value: '',
    config: {
      placeholder: 'Select smoke',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  drink: {
    type: 'async_select_single',
    label: 'Drink',
    value: '',
    config: {
      placeholder: 'Select drink',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const educationinfo = {
  qualification: {
    type: 'async_select_single',
    label: 'Qualification',
    value: '',
    config: {
      placeholder: 'Select qualification',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  profession: {
    type: 'async_select_single',
    label: 'Profession',
    value: '',
    config: {
      placeholder: 'Select profession',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  degree: {
    type: 'async_select_multiple',
    label: 'Degree',
    value: '',
    config: {
      placeholder: 'Select degrees',
      defaultOptions: true,
      help_text: 'You can select multiple options',
      isOptionDisabled: (value) => {
        return value.is_parent === true;
      },
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  about_education: {
    type: 'input',
    label: 'About your Education',
    value: '',
    config: {
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  work_profile: {
    type: 'async_select_single',
    label: 'Work Profile',
    value: '',
    config: {
      placeholder: 'Select work profile',
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  income: {
    type: 'async_select_single',
    label: 'Income',
    value: '',
    config: {
      placeholder: 'Select income range',
      defaultOptions: true,
      isSearchable: false,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  about_career: {
    type: 'input',
    label: 'About your Work Profile',
    value: '',
    config: {
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },

};


export const familyinfo = {
  father_name: {
    type: 'input',
    label: 'Father\'s Name',
    value: '',
    config: {
      placeholder: 'Your father\'s name',
      help_text: 'Enter only first name',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mother_name: {
    type: 'input',
    label: 'Mother\'s Name',
    value: '',
    config: {
      placeholder: 'Your mother\'s name',
      help_text: 'Enter only first name',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  father_occupation: {
    type: 'async_select_single',
    label: 'Father\'s Occupation',
    value: '',
    config: {
      placeholder: 'Select occupation',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mother_occupation: {
    type: 'async_select_single',
    label: 'Mother\'s Occupation',
    value: '',
    config: {
      placeholder: 'Select occupation',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  native_place: {
    type: 'input',
    label: 'Native Place',
    value: '',
    config: {
      placeholder: 'Your native place',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mosal: {
    type: 'input',
    label: 'Mosal (Surname)',
    value: '',
    config: {
      placeholder: 'Your mosal surname',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  nanaji: {
    type: 'input',
    label: 'Nanaji\'s name',
    value: '',
    config: {
      placeholder: 'Your nanaji\'s name',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  brother_count: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Total',
      type: 'number',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  brother_married: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Married',
      type: 'number',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  sister_count: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Total',
      type: 'number',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  sister_married: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Married',
      type: 'number',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};


export const contactinfo = {
  self_address: {
    type: 'input',
    label: 'Self/Office Address',
    value: '',
    config: {
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  self_city: {
    type: 'async_select_single',
    label: 'Self/Office City',
    value: '',
    config: {
      placeholder: 'Search and select city',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  self_contact_no: {
    type: 'input',
    label: 'Self/Office No.',
    value: '',
    config: {
      placeholder: 'Enter contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  family_address: {
    type: 'input',
    label: 'Family Residence Address',
    value: '',
    config: {
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  family_city: {
    type: 'async_select_single',
    label: 'Family Residence City',
    value: '',
    config: {
      placeholder: 'Search and select city',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  location: {
    type: 'input',
    label: 'Location',
    value: '',
    config: {
      placeholder: 'Location (eg. Santacruz, Kandivali, etc)',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  residence_type: {
    type: 'async_select_single',
    label: 'Residence Type',
    value: '',
    config: {
      placeholder: 'Select type of residence',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  rooms_count: {
    type: 'input',
    label: 'No. of rooms (BHK)',
    value: '',
    config: {
      type: 'number',
      placeholder: 'Enter how many BHK',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  residence_area: {
    type: 'input',
    label: 'Area in sqft.',
    value: '',
    config: {
      type: 'number',
      placeholder: 'Area in sqft.',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  residence_phone: {
    type: 'input',
    label: 'Residence Contact no.',
    value: '',
    config: {
      placeholder: 'Residence Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  father_contact: {
    type: 'input',
    label: 'Father\'s Contact no.',
    value: '',
    config: {
      placeholder: 'Father\'s Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mother_contact: {
    type: 'input',
    label: 'Mother\'s Contact no.',
    value: '',
    config: {
      placeholder: 'Mother\'s Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const referenceinfo = {
  name: {
    type: 'input',
    label: 'Name',
    value: '',
    config: {
      placeholder: 'Reference Name',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  phone: {
    type: 'input',
    label: 'Contact No.',
    value: '',
    config: {
      placeholder: 'Reference Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  place: {
    type: 'input',
    label: 'Location',
    value: '',
    config: {
      placeholder: 'Reference location',
      help_text: 'eg. Santacruz, Kandivali, etc',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const fileupload = {
  file: {
    type: 'file',
    label: 'Add new file',
    value: '',
    config: {
      type: 'file',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


const ageOptions = {};
for (let index = 19; index < 61; index += 1) {
  ageOptions[index] = index;
}


export const partnerchoice = {
  from_age: {
    type: 'select',
    label: 'From age',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: ageOptions,
  },
  to_age: {
    type: 'select',
    label: 'To age',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: ageOptions,
  },
  from_height: {
    type: 'select',
    label: 'From Height',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: heightOptions,
  },
  to_height: {
    type: 'select',
    label: 'To Height',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: heightOptions,
  },
  marital_status: {
    type: 'async_select_multiple',
    label: 'Marital Status',
    value: '',
    config: {
      placeholder: 'Select marital status',
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  caste: {
    type: 'async_select_multiple',
    label: 'Caste',
    value: '',
    config: {
      placeholder: 'Select caste',
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  qualification: {
    type: 'async_select_multiple',
    label: 'Qualifications',
    value: '',
    config: {
      placeholder: 'Select qualifications',
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  degree: {
    type: 'async_select_multiple',
    label: 'Degrees',
    value: '',
    config: {
      placeholder: 'Select degrees',
      isSearchable: false,
      defaultOptions: true,
      isOptionDisabled: (value) => {
        return value.is_parent === true;
      },
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  profession: {
    type: 'async_select_multiple',
    label: 'Professions',
    value: '',
    config: {
      placeholder: 'Select professions',
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  work_profile: {
    type: 'async_select_multiple',
    label: 'Work Profile',
    value: '',
    config: {
      placeholder: 'Select work profile',
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  income: {
    type: 'async_select_multiple',
    label: 'Income',
    value: '',
    config: {
      placeholder: 'Select income',
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  country: {
    type: 'async_select_multiple',
    label: 'Country',
    value: '',
    config: {
      placeholder: 'Select Country',
      isSearchable: true,
      defaultOptions: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  diet: {
    type: 'async_select_single',
    label: 'Diet',
    value: '',
    config: {
      placeholder: 'Select diet',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  smoke: {
    type: 'async_select_single',
    label: 'Smoke',
    value: '',
    config: {
      placeholder: 'Select smoke',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  drink: {
    type: 'async_select_single',
    label: 'Drink',
    value: '',
    config: {
      placeholder: 'Select drink',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  horoscope: {
    type: 'select',
    label: 'Horoscope Required?',
    value: '',
    config: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    options: {
      1: 'Yes',
      0: 'No',
    },
  },
};


export const deleteProfile = {
  reason: {
    type: 'select',
    label: 'Reason',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: {
      1: 'Marriage fixed through our matrimony',
      2: 'Marriage fixed through other sources',
      3: 'Prefer to search later',
      4: 'Not getting response as expected',
      5: 'Other reasons',
    },
  },
  message: {
    type: 'input',
    label: 'Message (optional)',
    value: '',
    config: {
      placeholder: 'Optional Message',
      multiline: true,
      rows: 4,
    },
    validation: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};



// WEBPACK FOOTER //
// ./src/profile/utils/profileFormStates.js